import React, {useEffect, useRef, useState} from 'react';
import {Check, User, X} from "react-feather";
import UserAvatar from "../../../components/Item/UserAvatar";
import CreateUserModal from "./CreateUserModal";
import ConfirmationModal from "../../../components/Modal/ConfirmationModal";


const ContactsSearch = ({
                            onDeleteContact,
                            onContactSelect,
                            selectedContacts,
                            selectedContact,
                            allVendorAccounts,
                            skipCreate = false,
                            disabled = false,
                            isPrimary = false,
                            onUserCreated,
                            type
                        }) => {

    const [searchTerm, setSearchTerm] = useState('');
    const [filteredVendorAccounts, setFilteredVendorAccounts] = useState(allVendorAccounts);
    const [isDropOpen, setIsDropOpen] = useState(false);
    const contactsRef = useRef();
    const [newUserModal, setNewUserModal] = useState(false);
    const [confirmRemove, setConfirmRemove] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const parentRef = useRef(null);
    const [showAbove, setShowAbove] = useState(false);
    const searchInputRef = useRef(null);

    const setDefaultFilteredList = () => {
        const temp = allVendorAccounts?.filter(vendor => {
            return !selectedContacts?.some(contact => contact?.id === vendor?.id) || (selectedContact && selectedContact?.id === vendor.id);
        });
        setFilteredVendorAccounts(temp);
    }

    useEffect(() => {
            setDefaultFilteredList();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [allVendorAccounts, selectedContact, selectedContacts]);


    const handleInputChange = (event) => {
        const value = event.target.value;
        if (allVendorAccounts?.length > 0)
            setIsSearching(true);

        const temp = allVendorAccounts?.filter(vendor => {
            return !selectedContacts?.some(contact => contact?.id === vendor?.id) || (selectedContact && selectedContact?.id === vendor.id);
        })

        if (value.length > 2) {
            setFilteredVendorAccounts(temp.filter(vendor => {
                const vendorName = (vendor.first_name + ' ' + vendor.last_name).toLowerCase();
                return vendorName.includes(value.toLowerCase());
            }));
            setIsDropOpen(true);
        } else
            setFilteredVendorAccounts(temp)
        setSearchTerm(value);
    };

    const vendorSelect = (vendor, isSame = false) => {
        setIsDropOpen(false);
        setIsSearching(false);
        if (!isSame)
            onContactSelect(vendor);
    };


    useEffect(() => {
        let handleClickOutside = (event) => {
            if (contactsRef.current && !contactsRef.current.contains(event.target)) {
                setIsDropOpen(false);
                setIsSearching(false);
                setSearchTerm('');
                setDefaultFilteredList()
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });

    useEffect(() => {
        let handleClickOutside = (event) => {
            if (searchInputRef.current && !searchInputRef.current.contains(event.target)) {
                setIsSearching(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });


    useEffect(() => {
        const checkPosition = () => {
            if (parentRef.current && contactsRef.current) {
                const parentRect = parentRef.current.getBoundingClientRect();
                const divRect = contactsRef.current.getBoundingClientRect();

                const spaceBelow = window.innerHeight - parentRect.bottom;
                const spaceAbove = parentRect.top;

                // Check if there's enough space below or above
                if (spaceBelow < divRect.height && spaceAbove >= divRect.height) {
                    setShowAbove(true);
                } else {
                    setShowAbove(false);
                }
            }
        };

        checkPosition();
        window.addEventListener('resize', checkPosition);
        return () => window.removeEventListener('resize', checkPosition);
    }, [isDropOpen]);

    const onDeleteClick = () => {
        setConfirmRemove(true);
    }

    const onConfirmRemove = async () => {
        setConfirmRemove(false);
        setIsDeleting(true);
        try {
            await onDeleteContact();
            setIsDeleting(false);
        } catch (e) {
            console.log(e)
            setIsDeleting(false);
        }

    }

    const onSearchClick = () => {
        setSearchTerm('');
        setDefaultFilteredList();
        setIsDropOpen((filteredVendorAccounts.length > 0 || !selectedContact))
        if (allVendorAccounts?.length > 0)
            setIsSearching(true);
    }


    const showSelected = isSearching ? false : !!selectedContact;

    const hasNew = (selectedContacts?.filter?.(item => item === null).length > 0 && selectedContacts.length === 2) || false;

    return (
        <div className="sl-flex sl-flex-col sl-gap-2 sl-align-stretch">
            {newUserModal &&
                <CreateUserModal type={type}
                                 onUserCreated={(values, type) => onUserCreated(values, type, selectedContact)}
                                 onClose={() => setNewUserModal(false)}/>}

            {confirmRemove && selectedContact &&
                <ConfirmationModal
                    title={`Remove Key Contact`}
                    message={<span className={"sl-font"}>You're about to remove <span
                        className={"sl-text-gray-900 sl-font-semibold sl-text-md sl-font"}>{selectedContact.first_name} {selectedContact.last_name}</span> as a key contact. This will unassign them from this role. Are you sure you want to proceed?</span>}
                    btnConfirm={"Remove"}
                    btnCancel={"Cancel"}
                    handleConfirm={onConfirmRemove}
                    handleClose={() => setConfirmRemove(false)}
                />}

            <div className={"sl-flex-row sl-flex sl-gap-2 sl-align-center sl-relative"}>
                <div
                    ref={parentRef}
                    style={{pointerEvents: disabled ? 'none' : 'auto'}}
                    onClick={onSearchClick}
                    className={`${disabled ? 'sl-bg-gray-100' : ''} sl-flex sl-cursor-pointer sl-align-center sl-flex-row sl-gap-2 sl-pl-16 sl-pr-16 sl-pt-10 sl-pb-10 sl-input sl-h-11 sl-border-1 sl-shadow-xs sl-rounded-lg sl-w-fill-available sl-flex`}>

                    {selectedContact && <UserAvatar userData={selectedContact}
                                                    avatarClass={`sl-h-6 sl-w-6 sl-flex sl-text-xs sl-shrink-0 sl-text-gray-600 sl-font sl-font-medium ${isSearching ? 'sl-opacity-50' : ''}`}/>}
                    {!selectedContact && <User size={20}/>}
                    <input
                        ref={searchInputRef}
                        value={showSelected ? selectedContact.first_name + ' ' + selectedContact.last_name : searchTerm}
                        onChange={handleInputChange}
                        className={`${disabled ? 'sl-bg-gray-100i' : 'sl-input'}  sl-border-none sl-text-gray-500 sl-font sl-text-md sl-font-normal sl-text-mdd sl-p-0i sl-w-fill-available`}
                        type="text"
                        placeholder={isSearching && selectedContact ? selectedContact.first_name + ' ' + selectedContact.last_name : 'Select a user'}
                    />

                    {!isDropOpen &&
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M5 7.5L10 12.5L15 7.5" stroke="#667085" strokeWidth="1.66667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"/>
                        </svg>}

                    {isDropOpen &&
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M15 12.5L10 7.5L5 12.5" stroke="#667085" strokeWidth="1.66667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"/>
                        </svg>}
                </div>
                {!isDeleting && !isPrimary && selectedContact && !hasNew &&
                    <div
                        className={"sl-h-10 sl-w-10 sl-hover-gray-100 sl-rounded-lg sl-cursor-pointer sl-flex sl-justify-center sl-align-center"}
                        onClick={onDeleteClick}>
                        <X size={20}
                           className=" sl-text-gray-base "/></div>
                }

                {isDeleting &&
                    <div
                        className={"sl-h-10 sl-w-10 sl-hover-gray-100 sl-rounded-lg sl-cursor-pointer sl-flex sl-justify-center sl-align-center"}
                    >
                        <div className="sl-w-8 sl-h-8 sl-loader sl-m-auto"/>
                    </div>}


                {isDropOpen &&
                    <div
                        ref={contactsRef}
                        className={`sl-z-10 sl-border-solid sl-border-1 sl-border-gray-100 sl-absolute sl-left-0 ${showAbove ? 'sl-bottom-8' : 'sl-top-12'} sl-w-full sl-bg-white sl-flex sl-shadow-lg sl-rounded-lg sl-flex-col sl-gap-0 sl-mb-6 sl-text-gray-900 sl-text-md`}>
                        <div
                            className={"sl-max-h-66 sl-h-auto sl-overflow-y-scroll sl-customized-scrollbar-rounded "}>
                            {filteredVendorAccounts.map((vendor, index) => (
                                <div
                                    key={index}
                                    rel={vendor.id}
                                    className={`sl-cursor-pointer sl-flex sl-justify-space-between sl-align-center  sl-py-10 sl-px-14 ${selectedContact?.id === vendor.id ? 'sl-bg-gray-50' : ''} sl-hover-gray-50`}
                                    onClick={() => vendorSelect(vendor, selectedContact?.id === vendor.id)}
                                >
                                    <div className={"sl-flex sl-flex-row sl-gap-2 sl-justify-flex-start sl-font"}>
                                        <UserAvatar userData={vendor}
                                                    avatarClass="sl-h-6 sl-w-6 sl-text-gray-600 sl-font sl-flex sl-text-xs sl-shrink-0 sl-font-medium "/>
                                        {vendor.first_name} {vendor.last_name}
                                    </div>
                                    {(selectedContact?.id === vendor.id) && <Check size={20} color={"#1570EF"}/>}
                                </div>
                            ))}
                        </div>
                        {filteredVendorAccounts.length === 0 && <div
                            className="sl-cursor-pointer sl-flex sl-justify-center sl-align-center sl-gap-2 sl-py-10 sl-px-14">
                            <div className="sl-font-medium sl-text-lg sl-text-gray-700 sl-font">Nothing found...</div>
                        </div>}

                        {!skipCreate && <div className={"sl-content-divider"} style={{
                            lineHeight: 0,
                            paddingTop: '10px',
                            paddingBottom: '6px'
                        }}></div>}
                        {!skipCreate && <div
                            key={filteredVendorAccounts.length + 1}
                            rel={filteredVendorAccounts.length + 1}
                            className="sl-flex sl-flex-row sl-gap-2 sl-cursor-pointer sl-flex sl-justify-flex-start sl-align-center sl-gap-2 sl-py-10 sl-pl-16 sl-pr-16 sl-hover-gray-100"
                            onClick={() => setNewUserModal(true)}
                        >
                            <span
                                className={"sl-text-primary-700 sl-font-medium sl-text-md sl-font"}>+ Create new user</span>
                        </div>}
                    </div>}
            </div>


        </div>
    );
};

export default ContactsSearch;
